module.exports = __webpack_public_path__ + "img/pt-30.54bef857.jpg";